import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { BookPaymentServiceService } from '../../shared/services/apis/platform/book-payment-service.service';
import { AlertService, AlertType } from '../../shared/services/alert.service';
import { BookServiceSellEnum } from '../../shared/services/enums/book-service-sell.enum';

@Component({
  selector: 'app-hire-formatter-modal',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './hire-formatter-modal.component.html',
  styleUrls: ['./hire-formatter-modal.component.css']
})
export class HireFormatterModalComponent {
  isLoading = false;
  idBookVersion: number;

  constructor(
    public dialogRef: MatDialogRef<HireFormatterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private bookPaymentServiceService: BookPaymentServiceService,
    private alertService: AlertService
  ) {
    this.idBookVersion = data;
  }

  onBack(): void {
    if (!this.idBookVersion) {
      this.alertService.show('Erro', 'Livro não identificado.', AlertType.error);
      this.dialogRef.close(false);
      return;
    }

    this.isLoading = true;

    this.bookPaymentServiceService.removeServiceFromCart(this.idBookVersion, BookServiceSellEnum.HIRE_FORMATTING).subscribe({
      next: (res) => {
        if (res.isError) {
          this.alertService.show('Erro ao remover serviço', res.errorDescription, AlertType.error);
        }
        this.alertService.show(
            'Serviço de capa recusado.',
            'Por favor, continue com o processo de criação da capa.',
            AlertType.warning
        );
        this.dialogRef.close(false);
      },
      error: (err) => {
        this.alertService.show('Erro inesperado', err, AlertType.error);
        this.dialogRef.close(false);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onContinue(): void {
    if (!this.idBookVersion) {
      this.alertService.show('Erro', 'Livro não identificado.', AlertType.error);
      this.dialogRef.close(false);
      return;
    }

    this.isLoading = true;

    this.bookPaymentServiceService.addServiceToCart(this.idBookVersion, BookServiceSellEnum.HIRE_FORMATTING).subscribe({
      next: (res) => {
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          this.dialogRef.close(false);
          return;
        }
        this.alertService.show(
            'Serviço de capa contratado!',
            'Entraremos em contato com você após a finalização do seu livro.',
            AlertType.success
        );
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.alertService.show('Erro inesperado', err, AlertType.error);
        this.dialogRef.close(false);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
}